function minReducer(acc, item) {
  let [productId, price] = Object.entries(item)[0];
  if (price < acc[1] && price !== 0) {
    acc = [productId, price];
  }
  return acc;
}

function maxReducer(acc, item) {
  let [productId, price] = Object.entries(item)[0];
  if (price > acc[1] && price !== 0) {
    acc = [productId, price];
  }
  return acc;
}

export function handleBmOutputProductSelection(selectedBmoutputDropdownItems, noneOptions, prodcutPriceMap) {
  let isNoneOptionSelected = selectedBmoutputDropdownItems?.remark?.length === 1 && noneOptions.includes(selectedBmoutputDropdownItems?.remark[0]);
  let isNothingSelected = Object.keys(selectedBmoutputDropdownItems?.remark || {}).length === 0;
  if (isNothingSelected || isNoneOptionSelected) {
    let [productId, price] = prodcutPriceMap.reduce(maxReducer, [0, 0]);
    return [productId, price];
  } else {
    let [productId, price] = prodcutPriceMap.reduce(minReducer, [0, Number.POSITIVE_INFINITY]);
    return [productId, price];
  }
}

export function handleBmOutputProductCancelationDateSelection(productCancelationDateMap) {
  let itemWithNoneNullCancelDate = productCancelationDateMap.filter((item) => {
    let key = Object.keys(item)[0];
    return item[key];
  })[0];
  let [productId, cancelDate] = Object.entries(itemWithNoneNullCancelDate)[0];
  return [productId, cancelDate];
}

export function subscribeToBmOutputService(erpAdapter, product_id, selectedBmoutputDropdownItems, noneOptions, setShouldFetch) {
  let remark = selectedBmoutputDropdownItems?.remark?.filter((remark) => !noneOptions.includes(remark)) || [];
  let body = { product_id: Number.parseInt(product_id) };
  const successCallback = (response) => setShouldFetch(true);
  if (remark.length !== 0) {
    body.remark = remark;
  }
  erpAdapter.fetchWithDelay("POST", "account/corporate/services/service/subscribe", body, successCallback, null, 4000);
}

export function unsubscribeToBmOutputService(erpAdapter, product_id, setShouldFetch) {
  let body = { product_id: Number.parseInt(product_id) };
  const successCallback = (response) => setShouldFetch(true);
  erpAdapter.fetch("POST", "account/corporate/services/service/unsubscribe", body, successCallback);
}

export function extractBmOutputExtraPropsFromService(
  service,
  setResetBmOutputDropdown,
  setBmOutputUpdate,
  confirmSubscribe,
  confirmUnsubscribe,
  translate,
  noneOptions,
  selectedBmoutputDropdownItems,
  setSelectedBmoutputDropdownItems,
  bmOutputUpdate,
  resetBmOutputDropdown,
  confirmBMSave
) {
  let extraProps = {};
  let service_id = service.service[0].service_id;

  let isSubscribed = service.products.some((product) => {
    let product_id = Object.keys(product)[0];
    let isCancelled = product[product_id]["subscription"]["status"] === "cancelled";
    return isCancelled ? true : product[product_id]["subscription"]["status"] === "subscribed";
  });

  let isCancelled = service.products.some((product) => {
    let product_id = Object.keys(product)[0];
    let isCancelled = product[product_id]["subscription"]["status"] === "cancelled";
    return isCancelled;
  });

  let prodcutPriceMap = service.products.map((product) => {
    let productId = Object.keys(product)[0];
    let price = product[productId]["details"]["price"];
    return { [productId]: price };
  });

  let productCancelationDateMap = service.products.map((product) => {
    let productId = Object.keys(product)[0];
    let cancelDate = product[productId]["subscription"]["cancel_date"];
    return { [productId]: cancelDate };
  });

  let name = service.service[0].sale_name;

  let cancelDate = null;

  service.products.forEach((product) => {
    let productId = Object.keys(product)[0];
    let productCancelDate = product[productId]["subscription"]["cancel_date"];
    if (productCancelDate) {
      cancelDate = new Date(productCancelDate);
    }
  });

  setResetBmOutputDropdown(false);

  let product_id = "BM_OUTPUT";

  let price = 0;

  let configs = service.dropdown.map((dropdown) => {
    const remarks = dropdown.remark || "";
    return {
      name: dropdown.label || "",
      ignoreSort: true,
      items: dropdown.values.map((item, index) => ({
        id: `${index + 1}`,
        label: item.name,
        active: remarks.includes(item.name),
      })),
    };
  });

  const dropdownConfigs = isSubscribed ? [] : configs;

  extraProps = {
    noneOptions,
    isSubscribed,
    isCancelled,
    onManage: () => (window.location.href = process.env.REACT_APP_BENCHMARKING_URL),
    onSubscribe: () => {
      setBmOutputUpdate(false);
      confirmSubscribe({ service_id, product_id, name, price, prodcutPriceMap }, translate);
    },
    onUnsubscribe: () => {
      if (isCancelled) {
        return null;
      }
      return confirmUnsubscribe({ service_id, product_id, name, price, cancelDate, productCancelationDateMap }, translate);
    },
    onSave: () => {
      setBmOutputUpdate(false);
      confirmBMSave({ service_id, product_id, name, price }, translate, service.dropdown[0].remark, selectedBmoutputDropdownItems);
    },
    options: {
      dropdownConfigs: dropdownConfigs,
      onDropdownChange: (name, selectedItems) => {
        setBmOutputUpdate(true);
        setSelectedBmoutputDropdownItems({ remark: selectedItems.map((item) => item.label) });
      },
      isSaveButtonActive: bmOutputUpdate,
      price: price,
      pricePhrase: translate("account.services.servicebox.price-phrase"),
      cancelDate,
      resetDropdown: resetBmOutputDropdown,
    },
  };
  return extraProps;
}
